const endpointName = 'Questions';
const Endpoints = {
  /**
   * @description getting questions
   * @param locale {string} = locale of the user
   * @returns a promise
   */
  getQuestions: function(locale) {
    //const filter = { include: { relation: 'region', scope: { include: 'country' } } };
    return this.get(`/api/${endpointName}?filter[order]=order%20ASC&filter[locale]=${locale}`);
  },
};

export default Endpoints;
